import { HttpErrorResponse } from '@angular/common/http';
import { Attribute, MetaData } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getAttributes = createAction('[AttributeFilters] Get Attributes');

export const getAttributesSuccess = createAction(
    '[AttributeFilters] Get Attributes Success',
    props<{ attributes: Attribute[]; metadata: MetaData | null; searchText: string | null }>()
);

export const getAttributesFailure = createAction('[AttributeFilters] Get Attributes Failure', props<{ error: HttpErrorResponse }>());

export const fetchAttributes = createAction('[AttributeFilters] Fetch Attributes');

export const searchAttributes = createAction(
    '[AttributeFilters] Get Attributes With Search',
    props<{ searchText: string; delay: number }>()
);

export const isLoadingAttributes = createAction('[AttributeFilters] Loading Attributes');

export const amendAttributeSelections = createAction('[AttributeFilters] Amend Selected Attributes');

export const getNextPageAttributes = createAction('[AttributeFilters] Get Next Page Attributes');

export const updateAttributesSelectionSuccess = createAction(
    '[AttributeFilters] Get Next Page Attributes Success',
    props<{ attributes: Attribute[]; metadata: MetaData | null }>()
);
